import ABCyaPhaser from "@abcya/abcya_phaser";
import TextUtils from "@abcya/abcya_phaser/src/js/Utils/GameObjects/UI/TextUtils";
import FontKeys from "../FontKeys";
import UIAssetKeys from "../UIAssetKeys";

export const CellStateIds = {
  ACTIVE: "active",
  CLEARED: "cleared",
};

export default class Cell extends Phaser.GameObjects.Container {
  constructor(
    scene,
    x,
    y,
    val,
    activeStateDisplay,
    clearedStateDisplay,
    labelColor,
    isInteractive
  ) {
    super(scene);

    this.x = x;
    this.y = y;

    this.displayStates = [];
    this.displayStates[CellStateIds.ACTIVE] = ABCyaPhaser.Images.addImage(
      0,
      0,
      activeStateDisplay ? activeStateDisplay : UIAssetKeys._PuzzleTile,
      this
    );
    this.displayStates[CellStateIds.ACTIVE].visible = false;

    this.displayStates[CellStateIds.CLEARED] = ABCyaPhaser.Images.addImage(
      0,
      0,
      clearedStateDisplay
        ? clearedStateDisplay
        : UIAssetKeys._PuzzleTileCleared,
      this
    );
    this.displayStates[CellStateIds.CLEARED].visible = false;

    this.highlightDisplay = ABCyaPhaser.Images.addImage(
      0,
      0,
      UIAssetKeys._HintHighlight,
      this
    );
    this.highlightDisplay.visible = false;

    this.displayStates[CellStateIds.ACTIVE].scaleX = 0.5;
    this.displayStates[CellStateIds.ACTIVE].scaleY = 0.5;
    this.displayStates[CellStateIds.CLEARED].scaleX = 0.5;
    this.displayStates[CellStateIds.CLEARED].scaleY = 0.5;
    this.highlightDisplay.scaleX = 0.5;
    this.highlightDisplay.scaleY = 0.5;

    const sizeRef = this.displayStates[CellStateIds.ACTIVE];
    /*
    this.hitBox = ABCyaPhaser.Graphics.addRect(
      0,
      0,
      sizeRef.width * 0.4,
      sizeRef.height * 0.4,
      0xff0000,
      this,
      { x: 0.5, y: 0.5 }
    );
    this.hitBox.alpha = 0.0001;
      */

    this.labelColor = labelColor ? labelColor : 0x1df4ff;

    this.label = TextUtils.addText(
      0,
      0,
      32,
      this.labelColor,
      FontKeys._nulshockbold,
      val.toString(),
      this,
      true
    );

    this.valueOverlay = TextUtils.addText(
      -16,
      -16,
      14,
      this.labelColor,
      FontKeys._nulshockbold,
      "",
      this,
      true
    );

    this.hideValueOverlay();

    this.currentDisplay = null;
    this.currentState = null;

    this.setValue(val);
  }

  setValue(val) {
    this.val = val ? val : 0;
    this.label.text = val.toString();
    if (this.val === 0) {
      this.setState(CellStateIds.CLEARED);
    } else {
      this.setState(CellStateIds.ACTIVE);
    }
  }

  showValueOverlay(val) {
    this.valueOverlay.text = val;
    this.valueOverlay.visible = true;
  }

  hideValueOverlay() {
    this.valueOverlay.visible = false;
  }

  emphasizeDisplay(returnDelay) {
    ABCyaPhaser.Tweens.addTween(
      this,
      100,
      {
        scaleX: 1.2,
        scaleY: 1.2,
      },
      Phaser.Math.Easing.Quadratic.Out
    );

    ABCyaPhaser.Tweens.addTween(
      this,
      100,
      {
        delay: returnDelay ? returnDelay + 100 : 100,
        scaleX: 1,
        scaleY: 1,
      },
      Phaser.Math.Easing.Quadratic.Out
    );
  }

  getValue() {
    return this.val;
  }

  setState(newState) {
    if (newState !== this.currentState) {
      switch (newState) {
        case CellStateIds.ACTIVE:
          this.setStateDisplay(CellStateIds.ACTIVE);
          this.label.visible = true;
          break;

        case CellStateIds.CLEARED:
          this.setStateDisplay(CellStateIds.CLEARED);
          this.label.visible = false;
          break;
      }
      this.currentState = newState;
    }
  }

  showHighlight() {
    this.highlightDisplay.visible = true;
  }

  hideHighlight() {
    this.highlightDisplay.visible = false;
  }

  getState() {
    return this.currentState;
  }

  setStateDisplay(stateId) {
    if (this.currentDisplay) {
      this.currentDisplay.visible = false;
    }
    this.currentDisplay = this.displayStates[stateId];
    this.currentDisplay.visible = true;
  }

  setListeners() {
    // if (!abcya.GameGlobalVars.game_paused) {
    /*
    this.hitBox.on(
      Phaser.Input.Events.GAMEOBJECT_POINTER_UP,
      this.onSelected,
      this
    );
    this.hitBox.setInteractive({ cursor: "pointer" });
      */
    /*
      if (!this.hasEventListener("click")) {
        this.on("click", this.onSelected, this);
        this.cursor = "pointer";
      }*/
    // }
  }
  /*
  onSelected(event) {
    this.setState(CellStateIds.CLEARED);
  }*/
}
